"use strict";

import React from 'react';
import PropTypes from 'prop-types';
import AppStore from '../stores/AppStore';
import rakutenLogo2x from '../../assets-virgin/images/rakuten_logo_top_bar@2x.png';
import virginLogoWhite2x from '../../assets-virgin/images/virgin_logo_top_bar_white@2x.png';
import arrowDotsPlay from '../../assets-virgin/images/arrow-dots-play-100.svg';
import virginToRakuten from '../../assets-virgin/images/virgin_to_rakuten.png';

/**
 * Virgin / Rakuten brand row for account pages (migration, sign-in).
 *
 * @param {Object} props
 * @param {boolean} [props.showBottomBorder]
 * @param {string} [props.className]
 * @param {boolean} [props.useCompositeImage] When true (default), render only the
 *        composite Virgin -> Rakuten banner image instead of the individual logos.
 */
const AccountMigrationBrandHeader = (props) => {
    const {showBottomBorder, className, useCompositeImage}  = props;
    const headerClass = [
        'container',
        'account-sign-in-brand-header',
        useCompositeImage ? 'account-sign-in-brand-header--composite' : '',
        showBottomBorder ? 'account-sign-in-brand-header--border-bottom' : '',
        className || ''
    ].filter(Boolean).join(' ');

    if (useCompositeImage) {
        return (
            <header className={headerClass} role="presentation">
                <img
                    className="account-sign-in-header__composite"
                    src={virginToRakuten}
                    alt={AppStore.translate('view.account_sign_in_page.rakuten_logo_alt')}
                />
            </header>
        );
    }

    return (
        <header className={headerClass} role="presentation">
            <div className="account-sign-in-header__virgin-badge">
                <img
                    className="account-sign-in-header__virgin-logo"
                    src={virginLogoWhite2x}
                    alt={AppStore.translate('view.account_sign_in_page.virgin_logo_alt')}
                />
            </div>
            <img
                className="account-sign-in-header__chevrons"
                src={arrowDotsPlay}
                alt=""
                aria-hidden="true"
            />
            <img
                className="account-sign-in-header__rakuten-logo"
                src={rakutenLogo2x}
                alt={AppStore.translate('view.account_sign_in_page.rakuten_logo_alt')}
            />
        </header>
    );
};

AccountMigrationBrandHeader.defaultProps = {
    showBottomBorder: true,
    useCompositeImage: true
};

AccountMigrationBrandHeader.propTypes = {
    showBottomBorder: PropTypes.bool,
    className: PropTypes.string,
    useCompositeImage: PropTypes.bool
};

export default AccountMigrationBrandHeader;
